import { useMemo } from 'react';
import { useGetReportsWithActionPlansCount } from '@/hooks/useGetReportsWithActionPlansCount';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { CUSTOM_REPORTS } from '../constants';

export interface ActionPlanReportWithCount {
	custom_report_id: string;
	report_name: string;
	formatted_name: string;
	icon: React.ReactNode;
	count: number;
}

export function useHandleActionPlans() {
	const { dataExtractionReport } = useDataExtractionReport();

	const { data: actionPlansCount = [] } = useGetReportsWithActionPlansCount({
		organization_id: dataExtractionReport?.organization_id || '',
		company_id: dataExtractionReport?.company_id || '',
		sector_id: dataExtractionReport?.sector_id,
		line_id: dataExtractionReport?.line_id,
		workstation_id: dataExtractionReport?.workstation_id,
		start_date: dataExtractionReport?.start_date,
		end_date: dataExtractionReport?.end_date
	});

	const actionPlanReports = useMemo(() => {
		return CUSTOM_REPORTS.map((reportConfig) => {
			const countData = actionPlansCount.find((data) => data.report_name === reportConfig.report_name);

			return {
				custom_report_id: countData?.custom_report_id || '',
				report_name: reportConfig.report_name,
				formatted_name: reportConfig.formatted_name,
				icon: reportConfig.icon,
				count: countData?.total_action_plans || 0
			};
		});
	}, [actionPlansCount]);

	return actionPlanReports;
}
